<figure *ngIf="!showEmptyState; else emptyState" class="highcharts-figure">
    <div [id]="'netFundPerf-'+parent"></div>
</figure>
<ng-template #emptyState><app-empty-chart></app-empty-chart></ng-template>
